import React, { type ReactElement, type JSX } from 'react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import styles from './Link.module.scss';
import useGameSlug from '../../hooks/useGameSlug';
import { useOptionalGame } from '@resources/js/contexts/useGame';
import { type GameSlug } from '../../config';

type LinkProps = {
  href: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: ReactElement<any> | string;
};

export default function Link(props: LinkProps): JSX.Element | null {
  const router = useRouter();
  const gameSlug = useGameSlug();
  const game = useOptionalGame();

  if (props.href.startsWith('/')) {
    const href = gameSlug
      ? getFullyQualifiedArticlePath(props.href, gameSlug)
      : props.href;

    const isActive =
      (href.endsWith('/') ? href.slice(undefined, -1) : href) === router.asPath;

    return (
      <NextLink
        {...props}
        href={href}
        className={isActive ? styles.isActive : undefined}
      >
        {props.children}
      </NextLink>
    );
  }

  if (props.href.startsWith('../')) {
    if (!game) {
      return null;
    }

    return <a {...props} href={game.baseUrl + props.href.substring(2)} />;
  }

  return <a {...props} target={'_blank'} rel={'noopener noreferrer'} />;
}

export function getFullyQualifiedArticlePath(
  path: string,
  gameSlug: GameSlug,
): string {
  return `/${gameSlug}/articles${path}`;
}
